import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Container, Paper, Typography, Button, Alert } from '@mui/material';
import { consumeViewerToken, savePdf } from '../services/viewerAccess';
export default function SecurePDFViewer() {
  const { reportId } = useParams();
  const [token] = useState(consumeViewerToken);
  useEffect(() => { window.history.replaceState(null, '', window.location.pathname + window.location.search); }, []);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true); setError('');
    try {
      const response = await axios.get((process.env.REACT_APP_API_URL || '') + '/api/secure-viewer/report/' + encodeURIComponent(reportId) + '/download',
        { headers: { Authorization: 'Bearer ' + token }, responseType: 'blob' });
      savePdf(response);
    } catch { setError('This report is unavailable for your account. Sign in or request a new verified-recipient link.'); }
    finally { setBusy(false); }
  };
  return <Container maxWidth="sm" sx={{ py: 6 }}><Paper sx={{ p: 4 }}>
    <Typography variant="h5">Report download</Typography>
    {error && <Alert severity="error">{error}</Alert>}
    <Button disabled={busy || !token} onClick={download}>Download report</Button>
    {!token && <Alert severity="info">Sign in or ask the sender for a verified-recipient link.</Alert>}
  </Paper></Container>;
}
